<ninety-card *ngrxLet="companyDeletionResult$ as companyDeletionResult" class="ninety-card">
  <ninety-card-header header>
    <div class="terra-title">Delete Company Data</div>
    <terra-form-field>
      <terra-text-input
        [formControl]="companyIdToDeleteSearch"
        placeholder="Enter company ID"
        (keydown.enter)="findCompanyById()">
        <terra-input-prefix class="search-icon">
          <terra-icon icon="search" />
        </terra-input-prefix>
      </terra-text-input>
      @if (companyIdToDeleteSearch.errors?.isObjectId) {
        <terra-error>Please enter a valid object id</terra-error>
      }
    </terra-form-field>
  </ninety-card-header>

  @if (companyToDelete) {
    <div class="card-content">
      <div class="found-company">
        @if (companyToDelete.logo?.url) {
          <img [src]="companyToDelete.logo.url" alt="company logo" class="company-logo" loading="lazy" />
        }
        <div class="flex1">
          {{ companyToDelete.name }}
        </div>
        <ninety-button filled negative (click)="openDeleteCompanyDialog()">
          <terra-icon icon="delete" />
          Hard Delete
        </ninety-button>
      </div>
    </div>
  }

  <div class="flex-1">
    @for (line of companyDeletionResult.split('\n'); track $index) {
      <div class="left-space-16">
        {{ line }}
      </div>
    }
  </div>
</ninety-card>
